import graphql__0a9f0be87a728029fca4 from "./__generated__/LinkedContribution_contribution.graphql.js";
import graphql__e9db135a9f7f0eaae47f from "./__generated__/LinkedContribution_parentContributionTheme.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { useRoutesContext } from "../../Routes/RoutesContext";
import ReactableMeasures from "./ReactableMeasures";
import UserAvatar from "../../Users/UserAvatar";
import UserAuthorName from "../../Users/UserAuthorName";
import Icon from "../../Utils/Icon";
import { themePathFor } from "../../Utils/themePathFor";
import { useResponsiveFlag } from "../../Utils/ResponsiveQueries";
import ButtonLink from "../../Buttons/ButtonLink";

const LinkedContribution = props => {
  const contribution = useFragment(LinkedContribution_contribution, props.contribution);
  const parentContributionTheme = useFragment(
    LinkedContribution_parentContributionTheme,
    props.parentContributionTheme
  );
  const { isDesktop, isNonDesktop } = useResponsiveFlag();

  const {
    author,
    title,
    themes,
    isFromAdminUser,
    slug: contributionSlug,
    participativeModule
  } = contribution;
  const { slug: participativeModuleSlug } = participativeModule;

  const className = classNames(
    "btn",
    "btn-block",
    "box-shadow-lg",
    "box",
    "contribution",
    "linked-contribution-box",
    {
      "margin-top-sm": isDesktop,
      "margin-top-lg": isNonDesktop,
      "admin-linked-contribution-highlight": isFromAdminUser
    }
  );

  const theme = themes.find(({ id }) => id === parentContributionTheme.id) || themes[0];
  const { rootTheme, subTheme, finalTheme } = themePathFor(theme);

  const subThemeIconClass = subTheme ? subTheme.iconClass : null;
  const iconClass = classNames(["align-middle", subThemeIconClass]);

  const { pathFor } = useRoutesContext();
  const contributionPath = pathFor("contribution", {
    participativeModuleSlug,
    contributionSlug
  });

  return (
    <article>
      <ButtonLink className={className} href={contributionPath}>
        <div className="contribution-box-top-label">
          <div
            style={{
              backgroundColor: rootTheme.primaryColor,
              color: rootTheme.primaryContrastColor
            }}
            className="theme"
          >
            {rootTheme.name}
          </div>

          {subTheme && (
            <div
              style={{
                backgroundColor: rootTheme.primaryColor,
                color: rootTheme.primaryContrastColor
              }}
              className="icon"
            >
              <Icon className={iconClass} />
            </div>
          )}
        </div>

        <div className="row author mb-2">
          <UserAvatar className="contribution-author-avatar" user={author} />

          <div>
            <UserAuthorName user={author} withStatusName={true} />
          </div>
        </div>

        <div className="title pointer mb-1">{title}</div>

        {finalTheme && (
          <span key={finalTheme.id} className="text-muted text-small padding-right-xs">
            {finalTheme.name}
          </span>
        )}

        <div className="reactions">
          <ReactableMeasures reactable={contribution} />
        </div>
      </ButtonLink>
    </article>
  );
};

const LinkedContribution_contribution = graphql__0a9f0be87a728029fca4;

const LinkedContribution_parentContributionTheme = graphql__e9db135a9f7f0eaae47f;

export default LinkedContribution;
